import { luftGet } from '../shared/http';
import { loggedUserRequestErrorHandler } from '../shared/http/error';

// ACTIONS
const GET_FILTERS_OPTIONS =
  'luft/operational-dashboard-configuration/GET_FILTER_OPTIONS';
const GET_FILTERS_OPTIONS_SUCCESS =
  'luft/operational-dashboard-configuration/GET_FILTER_SUCCESS';
const GET_FILTERS_OPTIONS_FAILURE =
  'luft/operational-dashboard-configuration/GET_FILTER_FAILURE';

// REDUCER
const INITIAL_STATE = {
  isFetching: false,
  error: false,
  clients: [],
  distribuctionCenters: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_FILTERS_OPTIONS:
      return {
        ...state,
        isFetching: true,
        error: false,
      };
    case GET_FILTERS_OPTIONS_SUCCESS:
      return {
        ...state,
        clients: action.clients,
        distribuctionCenters: action.distribuctionCenters,
        isFetching: false,
      };
    case GET_FILTERS_OPTIONS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
};

// ACTION CREATORS
const _getFiltersOptions = () => ({
  type: GET_FILTERS_OPTIONS,
});
const _getFiltersOptionsSuccess = (clients, distribuctionCenters) => ({
  type: GET_FILTERS_OPTIONS_SUCCESS,
  clients,
  distribuctionCenters,
});
const _getFiltersOptionsFailure = error => ({
  type: GET_FILTERS_OPTIONS_FAILURE,
  error,
});

// UTIL
const _formatFilters = filterOptions =>
  filterOptions.map(filterOption => ({
    label: filterOption.name,
    value: filterOption.id,
  }));

// THUNK ACTION CREATORS
export const getFiltersOptions = () => async dispatch => {
  dispatch(_getFiltersOptions);
  try {
    const response = await luftGet('/DashboardOperational/Configuration');
    dispatch(
      _getFiltersOptionsSuccess(
        _formatFilters(response.data.clients),
        _formatFilters(response.data.distribuctionCenters),
      ),
    );
  } catch (error) {
    loggedUserRequestErrorHandler(
      dispatch,
      error,
      _getFiltersOptionsFailure(error.message),
    );
  }
};
